import React from 'react';
import { GUEST_PATH } from '../../../../constants';

const AcceptYourSeat = React.lazy(() => import('./'));

const routes = {
     path: GUEST_PATH.ACCEPT_YOUR_SEATS,
     breadcrumb: 'Accept Your Seats',
     element: <AcceptYourSeat />,
};

export default routes;
